import { RefObject, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ComponentsDispatch } from '../store';
import { setterGant } from '../store/slices/gantSlice';

const useWidthContainer = (containerParent: RefObject<HTMLDivElement>) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const widthContainer = containerParent?.current?.getBoundingClientRect().width ?? 0;
    useEffect(() => {
        dispatch(setterGant({ availableWidth: widthContainer }));
    }, [widthContainer]);

    return widthContainer;
};

export default useWidthContainer;
